import { render, staticRenderFns } from "./Lessons.vue?vue&type=template&id=3416b9a6&scoped=true&"
import script from "./Lessons.vue?vue&type=script&lang=js&"
export * from "./Lessons.vue?vue&type=script&lang=js&"
import style0 from "./Lessons.vue?vue&type=style&index=0&id=3416b9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3416b9a6",
  null
  
)

export default component.exports